export default __webpack_public_path__ + "static/media/Nonny.bff04280.png";